module.exports = __webpack_public_path__ + "img/Icon-Menu.b8b9e842.svg";